import { Pipe, PipeTransform } from '@angular/core';
import { DataContextService } from 'src/app/services/datacontext.service';
import { DateHelper } from '../Helper/dateHelper';
import { DatePipe } from '@angular/common';
import { DaysOfWeek } from 'src/app/models/find-a-space.model';

@Pipe({
  name: 'weekDayTranslate'
})
export class WeekDayTranslatePipe implements PipeTransform {

  constructor(private dataContextService: DataContextService) {} 

    transform(value: any, format: string): string {
        const datePipe = new DatePipe('en-US');
        const date = new Date(DateHelper.RemoveOffsetFromDate(value));
        const dayOfWeek = date.getDay();
        const splittedFormat = format.split('');
        const eFormat = splittedFormat.filter(item => item.toLowerCase() == 'e');
        let result:string;
        const formattedDate = datePipe.transform(date, format);
        if (eFormat.length > 0 && eFormat.length <= 3) { //Abbr week day format 'E,EE,EEE'
            result = formattedDate.replace(DaysOfWeek[dayOfWeek].slice(0, 3), this.dataContextService.translateText(`Translation.${dayOfWeek}`).slice(0, 3));
            return result;
        }
        else if (eFormat.length == 4) { //Full week day format 'EEEE'
          result = formattedDate.replace(DaysOfWeek[dayOfWeek], this.dataContextService.translateText(`Translation.${dayOfWeek}`));
            return result;
        }
        else
            return formattedDate;
  }

}
